import React, { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { Header } from "../../components/Header";
import { useTranslation } from "react-i18next";
import { Footer } from "../../components/FooterV2";
import { B2cPlayground } from "./B2cPlayground";
import { OpenBanner } from "./OpenBanner";
import { useParams } from "react-router";
import { B2bPlayground } from "./B2bPlayground";
import { B2ePlayground } from "./B2ePlayground";
import { M2mPlayground } from "./M2mPlayground";
import "./styles.less";
export const OpenDetailPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const banner = {
    b2c: {
      tag: "b2c",
      title: "音乐平台项目实例",
      subtitle:
        "本项目将以一个 Github 上开源的音乐管理系统为例，介绍如何接入 Authing 服务到一个现成系统，帮助你快速开启数字化征程~",
      bg: "//files.authing.co/authing-website/open/playground-b2c.jpg",
      btnUrl:
        "//files.authing.co/authing-website/open/music-website-master.zip",
      btnName: "下载项目代码",
      link: "http://playground-b2c-client.authing.co/",
      linkName: "体验在线项目",
    },
    b2e: {
      tag: "b2e",
      title: "人事管理系统",
      subtitle:
        "本文将以一个 Github 上开源的人事管理系统为例，介绍如何接入 Authing ToB 服务到一个现成系统，帮助你快速开启数字化征程~",
      bg: "//files.authing.co/authing-website/open/playground-b2e.jpg",
      btnUrl: "//files.authing.co/authing-website/open/vhr-master.zip",
      btnName: "下载项目代码",
      link: "http://playground-b2e.authing.co",
      linkName: "体验在线项目",
    },
    b2b: {
      tag: "b2b",
      title: "周报系统项目",
      subtitle:
        "本文将以一个 Github 上开源的周报管理系统为例，将 Authing 的 多租户服务 接入到 ToC 的系统。帮助你快速开启数字化征程~",
      bg: "//files.authing.co/authing-website/open/playground-b2b-02.jpg",
      btnUrl: "//files.authing.co/authing-website/open/Playground-ToB-main.zip",
      btnName: "下载项目代码",
      link:
        "https://6w3zelsp324es2zt.authing.cn/63981463f8d0a068ad0d9878/login?_authing_lang=zh-CN&app_id=63981463f8d0a068ad0d9878&tenant_id=63a2e7b7b14104a4eb874977",
      linkName: "体验在线项目",
    },

    m2m: {
      tag: "m2m",
      title: "机器间授权",
      subtitle:
        "本文将以一个简单的 M2M 授权 Demo 为例，介绍如何接入 Authing ToC 服务到一个系统，帮助你快速开启数字化征程~",
      bg: "//files.authing.co/authing-website/open/playground-m2m.jpg",
      btnUrl: "//files.authing.co/authing-website/open/Playground-M2M-main.zip",
      btnName: "下载项目代码",
      link: "http://playground-m2m.authing.co",
      linkName: "体验在线项目",
    },
  };

  const Playground = {
    b2c: <B2cPlayground />,
    b2e: <B2ePlayground />,
    b2b: <B2bPlayground />,
    m2m: <M2mPlayground />,
  };

  return (
    <div className="open-detail-page">
      <Helmet>
        <title></title>
      </Helmet>
      <Header mode={id === "b2e" ? "dark" : "light"} />
      <OpenBanner {...banner[id]} />
      {Playground[id]}
      <Footer />
    </div>
  );
};
